import { CardTitle } from "react-migration/components/CardTitle";

export function UKPropertyInformationSelectionTitle() {
  return <CardTitle>Properties</CardTitle>;
}
